import { Injectable } from '@angular/core';

@Injectable()
export class ScrollService {

  constructor() { }

  public scrollTo(posX) {
    const bodyRect = document.body.getBoundingClientRect().top;

    window.scrollTo({top: posX - bodyRect, left: 0, behavior: 'smooth' });
  }
}